import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Download from '@mui/icons-material/Download';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHub from '@mui/icons-material/GitHub';
// import InstagramIcon from '@mui/icons-material/Instagram';
// import TwitterIcon from '@mui/icons-material/Twitter';

import Sideswicher from "./SideSwitcher/index";
import Typewriter from "./util/Typerwriter";
import { applySwitchAnimation } from "./SideSwitcher/sideswitcher-util";
import Resume from "./Resume";
import pdf from "../assets/Alissa_Paluska_Resume_2023_2.pdf";

export default function Home(props) {
    // const [width, setWidth] = useState(1200);
    // useEffect(() => {
    //     setWidth(window.innerWidth);
    // }, []);

    const intro = () => (
        <>
            <Typography variant="h4" style={{ color: '#555', fontWeight: 550 }}>Alissa Paluska</Typography>
            <Box sx={{ mt: 1, mb: 0 }}>
                <Typewriter statements={[
                    "Software Engineer",
                    "Avid Traveler",
                    "Novice Gardener",
                    "Enthusiastic Baker",
                    "Amateur Hand Embroider",
                    "",
                ]} />
            </Box>
            <Box sx={{ mt: 0, mb: 0 }}>
                <a
                    href="https://www.linkedin.com/in/alissa-paluska/"
                    style={{ color: '#b7d4a8' }}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <LinkedInIcon sx={{ mt: 5 }} />
                </a>
                <a
                    href="https://github.com/alissapaluska"
                    style={{ color: '#b7d4a8' }}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <GitHub sx={{ mt: 5, marginLeft: "8px" }} />
                </a>
                {/* <a
                    href="https://www.instagram.com/alissa.paluska/"
                    style={{ color: '#e1eddb' }}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <InstagramIcon className="login_form__icon" sx={{ mt: 5 }} />
                </a>
                <a
                    href="https://twitter.com/soupsawastin"
                    style={{ color: '#e1eddb' }}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <TwitterIcon className="login_form__icon" sx={{ mt: 5 }} />
                </a> */}
            </Box>
        </>
    );

    const about = () => (
        <Box className="switch_container__content right__init_switch">
            <Box>
                <Typography variant="h5" style={{ color: '#555', marginBottom: "5px" }}>A little bit about me...</Typography>
                <Typography variant="subtitle2" style={{ color: '#333' }}>I have 6+ years of experience in software engineering working in various industries such as drones, cybersecurity, location, and fintech. I am always eager to learn new technologies and frameworks. My goal is to leverage my skills and knowledge to create innovative and impactful solutions that solve real-world problems.</Typography>
                <Typography variant="subtitle2" style={{ color: '#555', marginTop: "18px", "fontSize": "0.8em", "fontWeight": 550 }}>Skills: Javascript, Node, Java, Python, Postgresql, Git, AWS, Event Streams, and REST APIs.</Typography>
                <Button sx={{ mt: 3, color: "#8dbb75", marginLeft: '-10px', "fontWeight": 550 }} onClick={(e) => { applySwitchAnimation() }} className="switch__button switch-btn">Resume</Button>
            </Box>
        </Box >
    );

    const resume = () => (
        <Box className="resume">
            <Resume resume={pdf} />
        </Box>
    );

    const downloadFile = (url, filename = '') => {
        if (filename.length === 0) filename = url.split('/').pop();
        const req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.responseType = 'blob';
        req.onload = function () {
            const blob = new Blob([req.response], {
                type: 'application/pdf',
            });

            const isIE = false || !!document.documentMode;
            if (isIE) {
                window.navigator.msSaveBlob(blob, filename);
            } else {
                const windowUrl = window.URL || window.webkitURL;
                const href = windowUrl.createObjectURL(blob);
                const a = document.createElement('a');
                a.setAttribute('download', filename);
                a.setAttribute('href', href);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        };
        req.send();
    };

    const downloadResume = () => (
        <>
            <Button
                onClick={(e) => { downloadFile(pdf, "Alissa_Paluska_Resume_2023") }}
                variant="primary"
                style={{ maxWidth: "200px", color: "#555" }}>
                <Download />
                Download
            </Button>
            <Button sx={{ mt: 2, mb: 2, color: "#ffce56", fontSize: "1em", fontWeight: 600, marginLeft: "-8px" }} onClick={(e) => { applySwitchAnimation() }} className="switch__button switch_btn">Home</Button>
        </>
    );

    return (
        <Sideswicher LeftInit={intro} RightInit={about} LeftPostSwitch={resume} RightPostSwitch={downloadResume} />
    );
};
